/*    
<summary>
   This file is used to provide initial values or state to the Device Module observables.
   Developer: Aashish Singh, Created Date: 12-June-2023
</summary>
*/

import { IRegisteredDeviceListVm } from "../../models/response/IRegisterDeviceResponse";

export const initialState: IRegisteredDeviceListVm = {
    PagingDetails: {
        TotalRecords: 1,
        TotalPages: 1,
        CurrentPage: 1,
        PageSize: 10,
    },
    Devices: []
}